/**
 * 模組代碼 : -
 * 模組說明 : (共用模組) 用於平滑滾動到指定區域
 * @module web/components/ScrollLink
 */
import React from 'react';

export default function ScrollLink({ to, children, className }) {
    const handleClick = (e) => {
        e.preventDefault();
        const target = document.querySelector(to); // to 例如 '#a02'
        if (target) {
            const top = target.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    };

    return (
        <a href={to} onClick={handleClick} className={className}>
            {children}
        </a>
    );
}
